import { DefaultService } from '@/services/DefaultService';

export default class ProdutoFamiliaService extends DefaultService {
	constructor(http, router, env) {
		super(http, router, env);
	}

	findAllCombo(limit = 50, situacao = 1, ...param) {
		return this._http
			.get(encodeURI(`${this._env}/produtofamilia/list-combo.json?limit=${limit}&param=${param}&situacao=${situacao}`), this._headers)
			.then((res) => { 
                return res.body; 
            }, (err) => {
                this.verifyError(err);
                throw new Error('Problems while jobs are loading');
			});
	}

	save(produtofamilia) {
		return this._http.post(`${this._env}/produtofamilia`, produtofamilia, this._headers).then(res => {
			return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}
}